export default "<iframe class=\"full\" src=\"https://app.termly.io/document/privacy-policy/ab84e772-a46e-4578-9962-a9a5f46b7891\"\r\n    ></iframe>"